import { render } from "./BookmarkletCard.vue?vue&type=template&id=6a45e602&scoped=true"
import script from "./BookmarkletCard.vue?vue&type=script&lang=js"
export * from "./BookmarkletCard.vue?vue&type=script&lang=js"

import "./BookmarkletCard.vue?vue&type=style&index=0&id=6a45e602&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a45e602"]])

export default __exports__